import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useI18nStore } from '../../store/i18nStore.js';

/**
 * Validates the `/:lang` URL segment and keeps the i18n store in sync.
 * Unknown lang values redirect to /en.
 */
export default function LangLayout() {
  const { lang } = useParams();
  const setLang = useI18nStore((s) => s.setLang);

  useEffect(() => {
    if (lang === 'id') setLang('ID');
    else if (lang === 'en') setLang('EN');
  }, [lang, setLang]);

  if (lang !== 'id' && lang !== 'en') {
    return <Navigate to="/en" replace />;
  }
  return <Outlet />;
}
